module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"order_history":"Order History"},"id":{"order_history":"Riwayat Pesanan"}}')
  delete Component.options._Ctor
}
